import React from "react";
import { Button } from "react-bootstrap";
import { FiCheck } from "react-icons/fi";

const CREDIT_FEATURES = [
  "AI-drafted name & description",
  "4 images per product",
  "Full HD image quality",
  "Credits never expire",
];

const TopupCard = ({ pack, isProcessing, onBuy }) => {
  return (
    <div
      className={[
        "billing-topup-card",
        pack.isBestValue ? "is-highlight" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {pack.isBestValue && (
        <span className="billing-topup-badge">Best value</span>
      )}

      <div className="billing-topup-head">
        <h3 className="billing-topup-tier">{pack.name}</h3>
        <span className="billing-topup-oneTime">one-time</span>
      </div>

      <div className="billing-topup-price-block">
        <div className="billing-topup-price">
          ₹{Math.round(pack.priceInPaise / 100).toLocaleString("en-IN")}
        </div>
        <div className="billing-topup-shoots">
          {pack.listingCount} product shoot{pack.listingCount === 1 ? "" : "s"}
        </div>
      </div>

      <Button
        className="billing-topup-cta"
        disabled={isProcessing}
        onClick={() => onBuy(pack)}
      >
        {isProcessing ? "Opening..." : "Buy credits"}
      </Button>

      <ul className="billing-topup-features">
        {CREDIT_FEATURES.map((feature) => (
          <li key={feature}>
            <FiCheck size={14} strokeWidth={2.5} />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TopupCard;
